'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _highcharts = require('./highcharts');

var _highcharts2 = _interopRequireDefault(_highcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    highcharts: _highcharts2.default
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/generators/index.js
 ** module id = 213
 ** module chunks = 0 1
 **/